import script from "./RetirementAge.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetirementAge.vue?vue&type=script&setup=true&lang=ts"

import "./RetirementAge.vue?vue&type=style&index=0&id=bd82aa54&lang=css"

const __exports__ = script;

export default __exports__